import dynamic from "next/dynamic";
import { useState } from "react";
import PlansList from "@/molecules/PlansList";

const LargerPlans = dynamic(() => import("@/molecules/LargerPlans"));

const BasicPlans = () => {
  const [isLargerPlansVisible, setIsLargerPlansVisible] = useState(false);

  const showLargerPlansHandler = () => {
    setIsLargerPlansVisible((prevState) => !prevState);
  };

  const basicPlans = [
    {
      cardOrderInMobile: 2,
      cardTitle: "Intro",
      minsPlusChat: "200 minutes + 50 chats",
      price: "349",
      setUpFree: "$75",
      additionalMins: "2",
      features: [
        "24/7 Live Answering",
        "Live Chat",
        "Business Phone Line",
        "Scheduling Solutions",
        "Mobile app",
        "Team Messaging",
      ],
      planid: process.env.IS_LIVE ? "5531" : "5515",
    },
    {
      cardOrderInMobile: 1,
      isBestValue: true,
      isMostPopularValue: true,
      cardTitle: "Best value",
      minsPlusChat: "300 minutes + 100 chats",
      price: "389",
      setUpFree: "No",
      btnVariant: "primary",
      additionalMins: "1.85",
      features: [
        "24/7 Live Answering",
        "Live Chat",
        "Business Phone Line",
        "Scheduling Solutions",
        "Mobile app",
        "Team Messaging",
      ],
      planid: process.env.IS_LIVE ? "5328" : "5311",
    },
    {
      cardOrderInMobile: 3,
      cardTitle: "Growth",
      minsPlusChat: "500 minutes + 200 chats",
      price: "669",
      setUpFree: "No",
      additionalMins: "1.85",
      features: [
        "24/7 Live Answering",
        "Live Chat",
        "Business Phone Line",
        "Scheduling Solutions",
        "Mobile app",
        "Team Messaging",
      ],
      planid: process.env.IS_LIVE ? "5329" : "5312",
    },
  ];

  return (
    <>
      <PlansList
        plansData={basicPlans}
        showLargerPlansHandler={showLargerPlansHandler}
        isLargerPlansVisible={isLargerPlansVisible}
      />
      {isLargerPlansVisible && <LargerPlans />}
    </>
  );
};

export default BasicPlans;
